document.addEventListener("DOMContentLoaded", () => {
    const inputs = document.querySelectorAll('.js-equip-fact-input');

    inputs.forEach(el => {
        updateModeCell(el);

        el.addEventListener('change', () => {
            updateModeCell(el);
        });
    });

    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            inputs.forEach(el => {
                updateModeCell(el);
            });
        }, 150);
    });
});

export function updateModeCell(input) {
    if (!input) return;

    const row = input.closest('tr');
    if (!row) return;

    const modeSelect = row.querySelector('select.js-mode-list');
    if (!modeSelect) return;

    const modeCell = modeSelect.closest('td');
    if (!modeCell) return;

    const isMobile = window.innerWidth <= 768;
    const isChecked = input.value > 0;
    const isExpanded = row.classList.contains('expanded');

    if (isMobile) {
        // Мобильная версия
        if (isChecked && isExpanded) {
            // Показываем ячейку с режимом работы
            modeCell.style.visibility = 'visible';
            modeCell.style.pointerEvents = 'auto';
            modeCell.style.opacity = '1';
            modeCell.style.maxHeight = '100px';
            modeCell.style.paddingTop = '8px';
            modeCell.style.paddingBottom = '8px';
            modeCell.style.borderTop = '1px solid #e5e7eb';
            modeCell.style.overflow = 'visible';
        } else {
            // Скрываем ячейку с режимом работы
            modeCell.style.visibility = 'hidden';
            modeCell.style.pointerEvents = 'none';
            modeCell.style.opacity = '0';
            modeCell.style.maxHeight = '0';
            modeCell.style.paddingTop = '0';
            modeCell.style.paddingBottom = '0';
            modeCell.style.borderTop = 'none';
            modeCell.style.overflow = 'hidden';
        }
    } else {
        // Десктопная версия: просто показываем/скрываем select
        modeCell.style.visibility = '';
        modeCell.style.pointerEvents = '';
        modeCell.style.opacity = '';
        modeCell.style.maxHeight = '';
        modeCell.style.paddingTop = '';
        modeCell.style.paddingBottom = '';
        modeCell.style.borderTop = '';
        modeCell.style.overflow = '';

        modeSelect.style.display = isChecked ? 'block' : 'none';
    }
}
